<template>
  <div>
  </div>

</template>

<script>

  export default {
    name: 'login',
    data: () => ({
    }),
    computed: {

    },
    methods: {
      
    }
  }
</script>
